import { AppointmentTypeName } from '~/lib/constants/scheduling.constants';
import { NoteCommunicationMethod } from '~/lib/constants/AddPatientNoteModal.constants';

export const deriveNewNoteCommunicationMethod = (
  appointmentType?: string,
  appointmentExternalId?: string,
) => {
  if (appointmentExternalId) {
    if (appointmentType === AppointmentTypeName.RECOVERY_NAVIGATOR_SESSION) {
      return NoteCommunicationMethod.OUTBOUND_PHONE;
    }
    return NoteCommunicationMethod.VIDEO;
  }
  return undefined;
};
